import { createContext } from 'react';

export const StringsContext = createContext({});
export const StringsProvider = StringsContext.Provider;
